<template>
  <div>
    <div class="domain-container">
      <div v-if="domain" style="background-color: white;border: .05rem solid #ced9e0;padding: 1rem;padding-bottom: 1.5rem;">
        <div style="margin: .5rem;border-bottom: .05rem solid #ced9e0;padding: 1rem;padding-left: 0;padding-top: 0;">选择您将配套学习的省/市{{ title }}：</div>
        <div style="display: flex;flex-direction: row; flex-wrap: wrap;padding-left: 1.5rem;padding-right: 1.5rem;padding-left: .5rem;">

          <div v-for="(d,index) of domain" @click="chose(d)" :key="index" style="display: flex;margin: .5rem;margin-left: 0;margin-right: 0;">
            <div style="height: 16px; font-size: 16px;line-height: 16px;display: inline-block;">
              <button class="chose-domain" >{{ d.name }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="outer-body">
      <a >
        <div>
          <div class="middle-main ">
            <img class="back-img" v-if="hytype === 0" :src="`${assetsUrl}imgs/course/hy-acc/jz.jpg`">
            <img class="back-img" v-if="hytype === 1" :src="`${assetsUrl}imgs/course/hy-acc/wm.jpg`">
            <img class="back-img" v-if="hytype === 2" :src="`${assetsUrl}imgs/course/hy-acc/jd.jpg`">
            <img class="back-img" v-if="hytype === 3" :src="`${assetsUrl}imgs/course/hy-acc/wl.jpg`">
            <img class="back-img" v-if="hytype === 4" :src="`${assetsUrl}imgs/course/hy-acc/fdc.jpg`">
            <img class="back-img" v-if="hytype === 5" :src="`${assetsUrl}imgs/course/hy-acc/sc.png`">
            <img class="back-img" v-if="hytype === 6" :src="`${assetsUrl}}imgs/course/hy-acc/wy.png`">
            <img class="back-img" v-if="hytype === 7" :src="`${assetsUrl}imgs/course/hy-acc/lxs.png`">
            <img class="back-img" v-if="hytype === 8" :src="`${assetsUrl}imgs/course/hy-acc/xz.png`">
            <img class="back-img" v-if="hytype === 9" :src="`${assetsUrl}imgs/course/hy-acc/gx.png`">
            <img class="back-img" v-else :src="`${assetsUrl}imgs/course/hy-acc/defualtHyBack.png`">
            <div>
              <a v-if="domainData.next_url" :href="domainData.next_url" target="_blank">
                <button class="button-hy" >进入</button>
              </a>
            </div>
          </div>
        </div>
      </a>
    </div>

  </div>
</template>

<script>

export default {
  name: 'APOITHyAcc',
  components: {
  },
  data() {
    return {
        assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
        user: {},
        domain: [],
        domainData: [],
        hytype: 3,
    }
  },
   props: {
    planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    },

  },
  created() {
    this.hytype = null
    const type = 'wl'
      if (type === 'wl') { // 物流
        this.hytype = 3
      } else if (type === 'fdc') { // 房地产
        this.hytype = 4
      } else if (type === 'jd') { // 酒店
        this.hytype = 2
      } else if (type === 'wm') { // 外贸
        this.hytype = 1
      } else if (type === 'jz') { // 建筑
        this.hytype = 0
      } else if (type === 'sc') { // 商场
        this.hytype = 5
      } else if (type === 'wy') { // 物业
        this.hytype = 6
      } else if (type === 'lxs') { // 旅行社
        this.hytype = 7
      } else if (type === 'xz') { // 行政事业单位
        this.hytype = 8
      } else if (type === 'gx') { // 高新技术企业
        this.hytype = 9
      }
  },
  methods: {
  },
}
</script>
<style scoped lang="less">
.outer-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.chose-domain{
  background-color: white;
  border: white .05rem solid;
  padding: .3rem;
  padding-right: .5rem;
  padding-left: .5rem;
  border-radius: .02rem;
  font-size: .7rem;
}
.chose-domain:hover {
  background-color: #00abff  ;
  color: white ;
}
.inner-div {
  width: 51.2rem;
  height: 38.4rem;
  //background-image: url("#{$assetsUrl}imgs/course/cpa/cpa-cost-back%20.jpg");
  background-image: url("https://o2o-demo.oss-cn-hangzhou.aliyuncs.com/o2ostu/assets/imgs/course/cpa/cpa-cost-back%20.jpg");
  background-repeat: no-repeat;
  background-size:  100% 100%;
  //background-image: url(assets/imgs/course/cpa-cost-back .jpg) no-repeat;
}
.main-div{
  width: 45.75rem;
  height:23rem;
  background-color: white;
  border-radius: .6rem;
  margin-top: 3.4rem;
  margin-left: 2.7rem;
  box-shadow: 0px 3px 13px rgba(0, 0, 0, .4);
}
.middle-main button {
  height: 3.3rem;
  width: 15.8rem;
  border: none;
  margin-right: 4rem;
  font-size: 1rem;
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  line-height: 3.3rem;
  outline: none;
}
.able-in:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}

@media (min-height: 750px) and (max-height: 825px){
  .inner-div,.middle-main{
    margin-top: 5rem;
    margin-bottom: 1rem;

  }
}
@media (min-height: 600px) and (max-height: 750px){
  .inner-div,.middle-main{
    margin-top: 8rem;
    margin-bottom: 3rem;
  }
  .middle-main{
    margin-top: 10rem;
  }
}
@media (min-height: 600px) and (max-height: 680px){
  .middle-main{
    margin-top: 15rem;
  }
}
@media screen and (max-height: 600px){
  .inner-div,.middle-main{
    margin-top: 18rem;
  }
}
.middle-main{
  position: relative;
  width: 51.3rem;
  height: 38.5rem;
  background-color: white;
  border:.05rem solid #E3E3E3;
}
.middle-main button{
  position: absolute;
  top: 23.7rem;
  right: 0;
  left: 0;
  margin: auto;
  background-color: white;
  color: #208ca5;
  font-size: 1.1rem;
  box-shadow: 0px 3px 0px #b1dbd9;
}
.middle-main button:hover{
  background-color: #98d172;
  color: white;
  box-shadow:none;
}

.middle-main button:active{
  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
}
.middle-title{
  width: 21.2rem;
  position: absolute;
  top: -7rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.middle-main .button-hy{
  color:#2a76c7;
}
</style>
